// gallery-fit-content: the shared contract for the embed→host height beacon. A content-card embed
// (ChatInterface, non-fill viewer) posts { type: EMBED_HEIGHT_MSG, height } to its parent window;
// the Gallery tile listens and sizes itself to the reported (clamped) height. One module so the
// sender and receiver can't drift on the message name or the bounds.

export const EMBED_HEIGHT_MSG = 'aveq:embed-height';

// gallery-touch-targets: the embed also posts its card's last-run time (epoch ms) so the host
// (the Gallery) can show it on the Refresh tooltip instead of a visible "Last run" line.
export const EMBED_LASTRUN_MSG = 'aveq:embed-lastrun';

// Clamp for a beaconed tile: floor avoids a collapsed sliver mid-load; ceiling stops a runaway card
// from dominating the board (it scrolls internally past this).
export const MIN_TILE = 120;
export const MAX_TILE = 760;

// Validate an inbound postMessage payload; return the raw reported height (>0) or null if it isn't a
// well-formed height beacon (wrong type, non-finite, non-positive, garbage from another sender).
export function parseEmbedHeight(data) {
  if (!data || data.type !== EMBED_HEIGHT_MSG) return null;
  const h = data.height;
  if (typeof h !== 'number' || !isFinite(h) || h <= 0) return null;
  return h;
}

// Clamp a reported height to the tile bounds (ceil to a whole px).
export function clampTileHeight(h) {
  return Math.min(MAX_TILE, Math.max(MIN_TILE, Math.ceil(h)));
}
